import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-dummy',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DummyComponent {}
